import { render } from "./DepotSupervisors.html?vue&type=template&id=0126a7cf&scoped=true"
import script from "./DepotSupervisors.js?vue&type=script&lang=js"
export * from "./DepotSupervisors.js?vue&type=script&lang=js"

import "./DepotSupervisors.css?vue&type=style&index=0&id=0126a7cf&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0126a7cf"]])

export default __exports__